/**
 * Portal Manta · htmlTabelaKPIs
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { Fonte } from '../shared/ArtefatoHelpers.jsx';

function htmlTabelaKPIs(titulo, schema, valores, fontes) {
  const linhas = [];
  Object.entries(schema).forEach(([k, bloco]) => {
    bloco.campos.forEach(c => {
      const v = valores[c.k];
      const preench = v !== undefined && v !== null && v !== '' && v !== 0;
      const f = fontes[c.k];
      const fBadge = f ? `<span class="badge b-${f === 'extraido' ? 'extraido' : f}">${f}</span>` : '<span class="b-empty">—</span>';
      linhas.push(`<tr>
        <td style="text-align:center;font-family:'Courier New',monospace;font-size:10px;color:#9CA3AF">${linhas.length+1}</td>
        <td style="text-align:center;font-family:'Courier New',monospace;font-size:10.5px;font-weight:600;color:#6B7280">${bloco.titulo.split('·')[0].trim()}</td>
        <td>${c.label}</td>
        <td style="text-align:center;color:#6B7280;font-family:'Courier New',monospace;font-size:10px">${c.sufixo||'—'}</td>
        <td style="${preench?'':'color:#9CA3AF;font-style:italic'}">${preench ? String(v) : '— vazio —'}</td>
        <td style="text-align:center">${fBadge}</td>
      </tr>`);
    });
  });
  return `<h2>${titulo}</h2>
<table>
  <thead><tr>
    <th style="width:36px;text-align:center">#</th>
    <th style="width:50px;text-align:center">Bloco</th>
    <th>Campo</th>
    <th style="width:70px;text-align:center">Unidade</th>
    <th>Valor</th>
    <th style="width:80px;text-align:center">Fonte</th>
  </tr></thead>
  <tbody>${linhas.join('')}</tbody>
</table>`;
}

export { htmlTabelaKPIs };
export default htmlTabelaKPIs;
